import { render, staticRenderFns } from "./junjiaxiangqing.vue?vue&type=template&id=516e73e9&scoped=true"
import script from "./junjiaxiangqing.vue?vue&type=script&lang=js"
export * from "./junjiaxiangqing.vue?vue&type=script&lang=js"
import style0 from "./junjiaxiangqing.vue?vue&type=style&index=0&id=516e73e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516e73e9",
  null
  
)

export default component.exports